import React from "react";
import { Container } from "./styled";

const Footer = () => {
  return (
    <Container>
      <p>Proyecto realizado por Mr. Average Man</p>
      <div className="flex_center_space-between footer-list_containers">
        <ul className="">
          <li className="footer-title">
            <b>Contacto</b>
          </li>
          <li>
            <a href="/contact">Contacto</a>
          </li>
          <li>
            <a href="/app/suscriptions">Suscripciones</a>
          </li>
          <li>
            <a href="/blog">Blog</a>
          </li>
        </ul>
        <div className="footer-info-container">
          <ul>
            <li className="footer-title">
              Nuestras redes
              <ul className="footer-list">
                <li>
                  <a
                    href="https://twitter.com/DeportacticoApp"
                    target="_blank"
                    className="twitter_link"
                    rel="noreferrer"
                  >
                    Twitter
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/@DeportacticoApp"
                    target="_blank"
                    className="youtube_link"
                    rel="noreferrer"
                  >
                    Youtube
                  </a>
                </li>
                <li>
                  <a
                    className="linkedin_link"
                    href="https://www.linkedin.com/company/deportactico/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Linkedin
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </Container>
  );
};

export default Footer;
